import React from 'react';
import { Users } from 'lucide-react';

export function UserRoleBadge({ user }) {
  const label = user.account_type === 'owner' ? 'Owner' : user.account_type === 'member'
    ? (user.role === 'admin' ? 'Team Admin' : 'Team Member') : 'Independent';
  return <span className="inline-block mt-1 px-2 py-0.5 rounded-full text-xs bg-slate-100 text-slate-700">{label}</span>;
}

export default function UserOrganizationCell({ user, onOpen }) {
  return (
    <td className="px-6 py-4">
      {user.organization_id ? (
        <button type="button" onClick={() => onOpen(user)}
          aria-label={`View team for ${user.email}`}
          className="text-left text-sm font-medium text-blue-700 hover:underline">
          <span className="flex items-center gap-2"><Users className="w-4 h-4" />
            {user.organization_name || 'View organization'}
          </span>
        </button>
      ) : <span className="text-sm text-gray-400 italic">No organization</span>}
      {user.workspace_name && <div className="text-sm text-gray-700 mt-1">{user.workspace_name}</div>}
      {user.workspace_subdomain && <div className="text-xs text-gray-500">{user.workspace_subdomain}.lexa.run</div>}
    </td>
  );
}
